import type { SolutionCreateParams } from '../dto/solution-create.dto';
import type { SolutionCreatePayload } from '../dto/solution.dto';
import { transmute } from '@/shared';

export class SolutionCreateMapper {
  static toCreateParams(params: SolutionCreateParams): SolutionCreatePayload {
    return transmute<SolutionCreatePayload>(params, [
      { key: 'name', defaultVal: '' },
      { key: 'case_maindata_id', from: 'caseMaindataId', defaultVal: 0 },
      { key: 'ga_factor_id', from: 'factorId', defaultVal: null },
      { key: 'type', from: 'solutionType' },
      { key: 'plan_setup_ai', from: 'planSetupAi', defaultVal: [] },
      { key: 'plan_setup_holo', from: 'planSetupHolo', defaultVal: [] },
      { key: 'plan_setup_mdps', from: 'planSetupMdps', defaultVal: [] },
    ]);
  }
}
